var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.65 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "apple") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.65,12.08a9.47,9.47,0,0,1-1,1.78c-.62,1-1.49,2.13-2.58,2.14s-1.21-.63-2.52-.62S5,16,4.05,16s-1.92-1.07-2.54-2C-.22,11.34-.41,8.23.66,6.59a3.85,3.85,0,0,1,3.1-1.86c1.15,0,1.87.63,2.82.63s1.48-.63,2.81-.63a3.73,3.73,0,0,1,2.83,1.49A3.24,3.24,0,0,0,12.65,12.08Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93,2.7A3.63,3.63,0,0,0,9.74,0,3.93,3.93,0,0,0,7.2,1.37,3.33,3.33,0,0,0,6.37,4,3.33,3.33,0,0,0,8.93,2.7Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.e5f245752d7b79c3cf270fec866676c1.svg";
export { ForwardRef as ReactComponent };